import { createAction, props } from '@ngrx/store';
import { OverviewEntity } from '../../models/overview.entities';

//-- PE for Offers, Banner & MicroMoments
export const loadMultiplePE = createAction(
  '[SkyMiles Overview/API] Load Multiple PE'
);

export const loadMultiplePESuccess = createAction(
  '[SkyMiles Overview/API] Load Multiple PE Data Overview Success',
  props<{ personalizationEngine: OverviewEntity }>()
);

export const loadMultiplePEFailure = createAction(
  '[SkyMiles Overview/API] Load Multiple PE Data Overview Failure',
  props<{ error: OverviewEntity }>()
);

//-- Status Tracker
export const loadTracker = createAction(
  '[SkyMiles Overview/API] Load Status Tracker'
);

export const loadTrackerSuccess = createAction(
  '[SkyMiles Overview/API] Load Status Tracker Data Overview Success',
  props<{ tracker: OverviewEntity }>()
);

export const loadTrackerFailure = createAction(
  '[SkyMiles Overview/API] Load Status Tracker Data Overview Failure',
  props<{ error: OverviewEntity }>()
);

//-- Future activities
export const loadFutureActivity = createAction(
  '[SkyMiles Overview/API] Load FutureActivities'
);

export const loadFutureActivitySuccess = createAction(
  '[SkyMiles Overview/API] Load FutureActivities Success',
  props<{ futureActivities: OverviewEntity }>() // Add modal for future activities
);

export const loadFutureActivityFailure = createAction(
  '[SkyMiles Overview/API] Load FutureActivities Failure',
  props<{ error: OverviewEntity }>()
);

//-- Membership Card
export const loadMembershipCard = createAction(
  '[SkyMiles Overview/API] Load MembershipCard'
);

export const loadMembershipCardSuccess = createAction(
  '[SkyMiles Overview/API] Load MembershipCard Data Success',
  props<{ membershipCards: OverviewEntity }>()
);

export const loadMembershipCardFailure = createAction(
  '[SkyMiles Overview/API] Load MembershipCard Data Failure',
  props<{ error: OverviewEntity }>()
);

//-- Voucher Count
export const loadVouchers = createAction(
  '[SkyMiles Overview/API] Load Vouchers'
);

export const loadVouchersSuccess = createAction(
  '[SkyMiles Overview/API] Load Vouchers Data Success',
  props<{ vouchers: OverviewEntity }>()
);

export const loadVouchersFailure = createAction(
  '[SkyMiles Overview/API] Load Vouchers Data Failure',
  props<{ error: OverviewEntity }>()
);

//-- eCredits Count
export const loadEDocs = createAction('[SkyMiles Overview/API] Load eDocs');

export const loadEDocsSuccess = createAction(
  '[SkyMiles Overview/API] Load Status eDocs Data Success',
  props<{ eDocs: OverviewEntity }>()
);

export const loadEDocsFailure = createAction(
  '[SkyMiles Overview/API] Load Status eDocs Data Failure',
  props<{ error: OverviewEntity }>()
);

//-- Snapshot - Account Activity
export const loadSnapshot = createAction(
  '[SkyMiles Overview/API] Load Snapshot'
);

export const loadSnapshotSuccess = createAction(
  '[SkyMiles Overview/API] Load Status Snapshot Data Success',
  props<{ snapshot: OverviewEntity }>()
);

export const loadSnapshotFailure = createAction(
  '[SkyMiles Overview/API] Load Status Snapshot Data Failure',
  props<{ error: OverviewEntity }>()
);

//-- MQD Earns Summary
export const loadEarnsSummary = createAction(
  '[SkyMiles Overview/API] Load MQD Earns Summary'
);

export const loadEarnsSummarySuccess = createAction(
  '[SkyMiles Overview/API] Load Status MQD Earns Summary Data Success',
  props<{ earnsSummary: OverviewEntity }>()
);

export const loadEarnsSummaryFailure = createAction(
  '[SkyMiles Overview/API] Load Status MQD Earns Summary Data Failure',
  props<{ error: OverviewEntity }>()
);

//-- SkyClub Tracker
export const loadSkyClubTracker = createAction(
  '[SkyMiles Overview/API] Load SkyClub Visit Tracker'
);

export const loadSkyClubTrackerSuccess = createAction(
  '[SkyMiles Overview/API] Load Status SkyClub Visit Tracker Data Success',
  props<{ skyClubTracker: OverviewEntity }>()
);

export const loadSkyClubTrackerFailure = createAction(
  '[SkyMiles Overview/API] Load Status SkyClub Visit Tracker Data Failure',
  props<{ error: OverviewEntity }>()
);

export const loadAmexSkyClubTracker = createAction(
  '[SkyMiles Overview/API] Load Amex SkyClub Visit Tracker'
);

export const loadAmexSkyClubTrackerSuccess = createAction(
  '[SkyMiles Overview/API] Load Status Amex SkyClub Visit Tracker Data Success',
  props<{ amexSkyClubTracker: OverviewEntity }>()
);

export const loadAmexSkyClubTrackerFailure = createAction(
  '[SkyMiles Overview/API] Load Status Amex SkyClub Visit Tracker Data Failure',
  props<{ error: OverviewEntity }>()
);
